import React from "react";
const KnowledgeBase: React.FC = () => <></>;
export default KnowledgeBase;
